import { Button, Statistic, Tooltip } from '@drip/drip-design';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './index.less';

const { Countdown } = Statistic;

function PopGuide() {
  const [visible, setVisible] = useState(true);
  const close = () => {
    setVisible(false);
    window.localStorage.setItem('SIGN_UP_POP_GUILD', 'false');
  };

  useEffect(() => {
    setVisible(!!(window.localStorage && !window.localStorage.getItem('SIGN_UP_POP_GUILD')));
  }, []);

  return visible ? (
    <div className="pop-guide">
      <div>可通过营销场景和活动玩法快速筛选出我适合报名的活动哦~</div>
      <div className="pop-guide-footer">
        <Countdown value={Date.now() + 8 * 1000} onFinish={close} format="s秒后自动关闭" className="count-down" />
        <Button type="primary" onClick={close} ghost>
          我知道了
        </Button>
      </div>
    </div>
  ) : null;
}

export default PopGuide;
export function MenuPopGuide(props: any) {
  const roleRules = useSelector((state: any) => state.userInfo.roleIsCargoOwner);
  const [visible, setVisible] = useState(false);
  const close = () => {
    setVisible(false);
    window.localStorage.setItem('MENU_POP_GUILD', 'false');
  };

  useEffect(() => {
    setVisible(!!(window.localStorage && !window.localStorage.getItem('MENU_POP_GUILD')) && roleRules);
  }, [roleRules]);

  return (
    <Tooltip
      title={
        <span>
          “活动报名”列表整合了全部可报名的主题活动、会场活动、综合促销、平台/行业频道活动，快来报名吧～
          <Countdown value={Date.now() + 8 * 1000} onFinish={close} format="" style={{ height: 0 }} />
        </span>
      }
      overlayClassName="menu-pop-guide"
      color="blue"
      visible={visible}
      placement="right"
    >
      {props.children}
    </Tooltip>
  );
}
